<form  #form="ngForm">
    <app-layout-row margin="0">
        <app-layout-column [width]="12">
            <div class="inputandmessage-container">
                <div class="typeandvalue">
                    <app-textbox [ngModel]="value()" name="field" [caption]="caption()" [readonly]="readonly()" [required]="isRequired" [pattern]="pattern()"></app-textbox>
                    <app-onboarding-comments-icon [disabled]="!allowConversation()" (clicked)="toggleConversation(conversationId(), null)" [hasUnreadMessages]="hasUnreadMessages(conversationId())"></app-onboarding-comments-icon>
                </div>
                @if (conversationId() && conversationId()===conversationToShow()?.Id) {
                    <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation(conversationId(), null)">
                        <app-conversation 
                            [conversation]="conversationToShow()"
                            [readonly]="readonlyConversation()" 
                            (postNewMessageClicked)="newComment($event, $safeNavigationMigration(conversationToShow()?.Id))">
                        </app-conversation>
                    </app-onboarding-comments-container>
                }
            </div>
        </app-layout-column>
    </app-layout-row>
</form>